/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import ContentCopyRoundedIcon from '@mui/icons-material/ContentCopyRounded';
import OpenInFullRoundedIcon from '@mui/icons-material/OpenInFullRounded';
import { Button } from '@mui/material';
import type { ReactNode } from 'react';

interface MarkdownArtifactActionProps {
  ariaLabel: string;
  children: ReactNode;
  icon: 'check' | 'copy' | 'expand';
  onClick: () => void;
}

const iconSx = { fontSize: 12 };

function MarkdownArtifactAction({
  ariaLabel,
  children,
  icon,
  onClick,
}: Readonly<MarkdownArtifactActionProps>) {
  return (
    <Button
      aria-label={ariaLabel}
      size="small"
      startIcon={iconForAction(icon)}
      onClick={onClick}
      sx={{
        minWidth: 0,
        px: 0.75,
        py: 0.25,
        color: 'text.secondary',
        fontSize: 11,
        fontWeight: 600,
        lineHeight: 1.2,
        textTransform: 'none',
        '& .MuiButton-startIcon': {
          mr: 0.5,
        },
      }}
    >
      {children}
    </Button>
  );
}

const iconForAction = (icon: MarkdownArtifactActionProps['icon']) => {
  if (icon === 'check') return <CheckOutlinedIcon sx={iconSx} />;
  if (icon === 'copy') return <ContentCopyRoundedIcon sx={iconSx} />;
  return <OpenInFullRoundedIcon sx={iconSx} />;
};

export default MarkdownArtifactAction;
